/**
 * Shared file upload error messages used across components.
 * Both English and Polish translations are maintained in pl.json.
 * Only Polish (pl) values are exported for use in the UI.
 */
import labels from './pl.json';

type LabelKey = keyof typeof labels;

export const SHARED_FILE_ERRORS = Object.fromEntries(
  Object.entries(labels).map(([key, value]) => [key, value.pl])
) as { [K in LabelKey]: string };
